import React from 'react';
import { Header, PageContainer, PageContent, Sidebar } from '../../layouts';
import { Button, CheckBox, InputField, TextArea, TitleLarge } from '../../components';
import { DELETE_ICON, SAVE_ICON } from '../../utils/consts';

const ProjectDetailPage = () => {
	return (
		<>
			<Header />
			<PageContainer>
				<Sidebar />
				<PageContent>
					<TitleLarge>Projektdetails</TitleLarge>
					<div className='container my-5'>
						<div className='row justify-content-center'>
							<div className='col-12 col-sm-8'>
								<h5>Von Nikolay Malygin</h5>
								<form>
									<InputField
										id={'project_name'}
										classes={'background-secondary'}
										type={'text'}
										label={'Projektname'}
										value={'Online-Lernportal'}
										onChange={() => {}}
									/>
									<TextArea
										id={'project_desc'}
										classes={'background-secondary'}
										style={{ minHeight: '150px', maxHeight: '350px' }}
										label={'Beschreibung'}
										value={
											'Entwurf und Implementierung eines interaktiven Online-Lernportals für Schüler: Eine benutzerfreundliche Plattform, die personalisierte Lernressourcen, interaktive Übungen und Fortschrittsverfolgung bietet. Ziel: Effektive und individualisierte Bildungsförderung für Schüler aller Altersgruppen.'
										}
										onChange={() => {}}
									/>
									<InputField
										id={'project_url'}
										classes={'background-secondary'}
										type={'url'}
										label={'Projekt-URL'}
										value={'https://www.onlineportal.at'}
										onChange={() => {}}
									/>
									<CheckBox
										id={'is_permanent'}
										label={'Permanent'}
										classes={'background-tertiary'}
									/>
									<CheckBox
										id={'is_finished'}
										label={'Abgeschlossen'}
										classes={'background-tertiary'}
									/>
									<div className='d-flex justify-content-end mt-4 gap-3'>
										<Button
											classes={'background-red px-4 py-2'}
											icon={DELETE_ICON}>
											Löschen
										</Button>
										<Button
											classes={'background-blue px-4 py-2'}
											icon={SAVE_ICON}>
											Speichern
										</Button>
									</div>
								</form>
							</div>
						</div>
					</div>
				</PageContent>
			</PageContainer>
		</>
	);
};

export default ProjectDetailPage;
